module.exports = __webpack_public_path__ + "static/img/player_head_17.00affa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_17.jpg
// module id = NfXh
// module chunks = 1